import React, { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../firebase";

// Datos que se piden al crear la cuenta; si falta alguno (por ejemplo al entrar con Google) se completan antes de usar la app
export const isProfileComplete = (profile) =>
  !!profile &&
  !!(profile.displayName || "").trim() &&
  !!(profile.phone || "").trim() &&
  !!(profile.point || "").trim();

const UserProfileContext = createContext({ loading: true, profile: null, isComplete: false });

export const useUserProfile = () => useContext(UserProfileContext);

// Perfil del usuario (users/{uid}) en tiempo real
export const UserProfileProvider = ({ children }) => {
  const [user, authLoading] = useAuthState(auth);
  const [state, setState] = useState({ loading: true, profile: null });

  useEffect(() => {
    if (authLoading) return undefined;
    if (!user) {
      setState({ loading: false, profile: null });
      return undefined;
    }
    setState((prev) => ({ ...prev, loading: true }));
    return onSnapshot(
      doc(db, "users", user.uid),
      (snapshot) => setState({ loading: false, profile: snapshot.exists() ? snapshot.data() : null }),
      () => setState({ loading: false, profile: null })
    );
  }, [user, authLoading]);

  return (
    <UserProfileContext.Provider value={{ ...state, isComplete: isProfileComplete(state.profile) }}>
      {children}
    </UserProfileContext.Provider>
  );
};
